import { get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr';




export async function getCaseBucket() {

  const payload = {
    apiName: 'LivisiblyCaseBucketApi',
    path: `case/bucket`

  }

  const restOperation = get(payload);


  const response = await restOperation.response;


  return processResponse(response)
}






// The current case's bucket name. Keyed on the case so a case switch never reuses
// another case's bucket; fixed for the life of a case, so never revalidated.
export function useCaseBucketName(caseId, shouldFetch = true) {
  const result = useSWR(shouldFetch && caseId ? ['CASE_BUCKET', caseId] : null, () => getCaseBucket(), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
  });
  return { ...result, bucketName: result.data?.bucketName };
}
